import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footer">Made with ❤️ by Dishant Sethi</div>
    </>
  );
};

export default Footer;
